/**
 * 聊天接口即使 HTTP 200 也可能返回业务错误；网络失败时旧请求拦截器还会返回 null。
 * 只有明确的 code=0 才允许调用方把结果当作会话数据，避免误建轮次或清空列表。
 */
export function requireChatResponse(response, fallbackMessage) {
  if (!response || Number(response.code) !== 0) {
    throw new Error(response?.msg || fallbackMessage)
  }
  return response
}
